import { render, staticRenderFns } from "./parsers.vue?vue&type=template&id=67b9d960&"
import script from "./parsers.vue?vue&type=script&lang=js&"
export * from "./parsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports